import styled, { keyframes } from 'styled-components'
import { Text } from '@pancakeswap/uikit'

interface TextProps {
  fontSize?: string
}
const shimmer = keyframes`
  0% {
    background-position: -500px 0;
  }
  100% {
    background-position: 500px 0;
  }
`

const removeShadow = keyframes`
  0% {
    text-shadow: 0px 0px 4px rgba(255, 255, 255, 1); 
  }
  100% {
    text-shadow: none;
  }
`

export const HomeGradient = styled(Text)<TextProps>`
  background: linear-gradient(to bottom right, #fff, #0154fe);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  font-size: ${(props) => props.fontSize || '16px'};
`

export const HomeGradientReverse = styled(Text)<TextProps>`
  background: linear-gradient(to right, #68b9ff, #fff, #68b9ff);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  font-size: ${(props) => props.fontSize || '16px'};
`

export const BaseSwapGradient = styled(Text)<TextProps>`
  text-align: ${(props) => props.fontSize || 'center'};
  color: rgba(255, 255, 255, 0.1);
  background: linear-gradient(90deg, #fff, #0154fe, #fff);
  background-size: 500px 100%;

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: ${(props) => props.fontSize || '16px'};
  animation: ${shimmer} 7s infinite linear, ${removeShadow} 3s forwards;
  -webkit-animation: ${shimmer} 7s infinite linear, ${removeShadow} 3s forwards;
`

export const MoneyGradient = styled(Text)<TextProps>`
  text-align: ${(props) => props.fontSize || 'center'};
  color: rgba(255, 255, 255, 0.1);
  background: linear-gradient(90deg, #fff, rgba(0, 255, 0), #fff);
  background-size: 500px 100%;

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: ${(props) => props.fontSize || '16px'};
  animation: ${shimmer} 7s infinite linear, ${removeShadow} 3s forwards;
  -webkit-animation: ${shimmer} 7s infinite linear, ${removeShadow} 3s forwards;
`
